<template>
  <aside class="payment-sidebar">
    <div class="contents">
      <div v-for="(item, key) in cart.airportparking" :key="`ap-${key}`" class="mb-3">
        <basket-parking-item :product="item.product" :quote="item.quote" />
      </div>
      <div v-for="(item, key) in cart.airporthotel" :key="`ah-${key}`" class="mb-3">
        <basket-hotel-item :product="item.product" :quote="item.quote" />
      </div>
      <div v-for="(item, key) in cart.airportlounge" :key="`al-${key}`" class="mb-3">
        <basket-lounge-item :product="item" :quote="item.quote" :upgrade="cart.airportparking.length > 0" />
      </div>
      <div v-for="(item, key) in cart.addon" :key="`ad-${key}`">
        <basket-addon-item :product="item" />
      </div>
      <div class="pay-info style01" v-if="credits > 0">
        <div class="pay-heading">
          <strong class="heading">{{ $t('payment.basket.customer_credits') }}</strong>
          <strong class="price price-addon">- {{ currency }}{{ credits > total ? total : credits.toFixed(2) }}</strong>
        </div>
      </div>
      <div class="pay-info">
        <div class="pay-heading" v-if="!upgrade">
          <strong class="heading">{{ $t('payment.basket.total_to_pay') }}</strong>
          <strong class="price">{{ currency }}{{ basketTotal }}</strong>
        </div>
        <p>
          {{ $t('payment.basket.on_making_payment') }} 
          <a :href="terms" target="_blank">{{ $t('payment.basket.terms') }}.</a>
        </p>
      </div>
    </div>

    <router-link v-if="upgrade" to="/payment" class="btn btn-primary skip-btn">{{ $t('payment.basket.skip') }}</router-link>
  </aside>
   
</template>

<script>
import { sync, get } from "vuex-pathify";
import mixins from "@/mixins";
import { BasketParkingItem, BasketHotelItem, BasketAddonItem, BasketLoungeItem} from "@/components";

export default {
  name: 'basket',
  components: { BasketParkingItem, BasketHotelItem, BasketAddonItem, BasketLoungeItem },
  mixins: [mixins.globals],
  computed: {
    quote: get("quote"),
    cart: sync("cart/products"),
    vehicles: get("payment/vehicles"),
    total: get("cart/total"),
    credits: get("customer/credits"),
    basketTotal() {
      let amount = this.credits > 0 ? (this.total - this.credits) : this.total;
      return parseFloat(amount > 0 ? amount : 0).toFixed(2);
    }
  },
  props: { upgrade: { default: false, type: Boolean } }
};
</script>